import Image from 'next/image';
import styled from 'styled-components';
import { Rating } from 'react-simple-star-rating';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
SwiperCore.use([Navigation]);
import getTimeAgo from '../../utils/getDateTime';
import { sourceIcon } from '../../utils/sourceIcon';
import { useEffect, useState } from 'react';
import DetailedReviewModal from './detailedReviewModal';
import {
  LeftSwipperArrows,
  RightSwipperArrows
} from '../SwipperArrows/SwipperArrows';
export interface Review {
  id: string;
  review: string;
  traveller: string;
  rating: number;
  source: string;
  created_at?: string;
  date?: string;
}
interface IProps {
  filterReviews: Review[];
  heading: string;
  productName?: string;
}

export const TextShadow = styled.h1`
  text-shadow: 1px -42px 1px rgba(51, 51, 51, 0.1);
`;

const Testimonials = ({ filterReviews, heading, productName }: IProps) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState<Review>();
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [isFirstSlide, setIsFirstSlide] = useState(false);
  const handleSlideChange = (swiper: any) => {
    setIsLastSlide(swiper.isEnd);
    setIsFirstSlide(swiper.isBeginning);
  };
  const handleSwiperInit = (swiper: any) => {
    setIsFirstSlide(swiper.isBeginning);
    setIsLastSlide(swiper.isEnd);
  };

  const names = [
    'Alice',
    'Bob',
    'Charlie',
    'David',
    'Eva',
    'Frank',
    'Grace',
    'Henry',
    'Ivy',
    'Jack',
    'Kate',
    'Leo',
    'Mia',
    'Nathan',
    'Olivia',
    'Paul',
    'Quinn',
    'Ryan',
    'Sophie',
    'Tom',
    'Uma',
    'Victor',
    'Wendy',
    'Xander',
    'Yvonne',
    'Zane'
  ];
  const generateRandomNames = () => {
    return names.map(() => names[Math.floor(Math.random() * names.length)]);
  };
  const [selectedRandomName, setSelectedRandomName] = useState('');

  const [randomNames] = useState(generateRandomNames());

  const handleSeeMoreClick = (review: Review, randomName: string) => {
    setSelectedReview(review);
    setShowModal(true);
    setSelectedRandomName(randomName);
  };

  return (
    <section id="testimonials" className="mb-3 lg:mb-5 lg:pb-6">
      <div className="  max-w-[1750px] mx-auto">
        {heading !== '' && (
          <div>
            <h2
              className={`text-[#131313] ${
                heading === 'Our Reviews' || heading === 'Traveller Reviews'
                  ? 'text-left'
                  : 'text-center'
              } md:text-start text-lg lg:text-3xl font-semibold `}
            >
              {heading}
            </h2>
          </div>
        )}

        <div
          id="slider-container"
          className="xxsm:max-h-[450px] lg:max-h-[350px] h-[100%] w-full mt-5 relative cursor-pointer"
        >
          <div
            id="slider-grid"
            className={`flex justify-between ${
              productName !== undefined ? 'h-[280px]' : 'h-[240px]'
            } gap-2 sm:gap-5`}
          >
            <Swiper
              slidesPerView="auto"
              spaceBetween={20}
              grabCursor={false}
              onSlideChange={(swiper: any) => handleSlideChange(swiper)}
              onInit={(swiper: any) => handleSwiperInit(swiper)}
              navigation={{
                nextEl: heading === '' ? '.custom-next-button' : '.nextBtn',
                prevEl: heading === '' ? '.custom-prev-button' : '.prevBtn'
              }}
              lazy
              breakpoints={{
                320: {
                  slidesPerView: Math.min(filterReviews?.length, 1.1),
                  spaceBetween: 10
                },
                360: {
                  slidesPerView: Math.min(filterReviews?.length, 1.2),
                  spaceBetween: 10
                },
                640: {
                  slidesPerView: Math.min(filterReviews?.length, 2),
                  spaceBetween: 20
                },
                1024: {
                  slidesPerView: 1,
                  spaceBetween: 20
                },
                1400: {
                  slidesPerView:
                    productName !== undefined
                      ? Math.min(filterReviews?.length, 2)
                      : Math.min(filterReviews?.length, 3),
                  spaceBetween: 20
                },
                1600: {
                  slidesPerView: Math.min(filterReviews?.length, 3),
                  spaceBetween: 20
                },
                2200: {
                  slidesPerView: Math.min(filterReviews?.length, 4),
                  spaceBetween: 20
                }
              }}
            >
              {filterReviews?.map((dt, index) => (
                <SwiperSlide
                  key={dt.id}
                  className="rounded-md outline-none overflow-hidden cursor-pointer hover:cursor-default"
                >
                  <div className=" bg-[#FAFAFA] flex flex-col justify-between relative py-3 px-5 rounded-md shadow-md h-full pb-4 pt-6 ">
                    <div>
                      <div className="flex justify-center text-center">
                        <Image
                          src={sourceIcon(dt.source)}
                          width={
                            dt.source?.trim().toLocaleLowerCase() ===
                              'website' || !dt.source
                              ? 50
                              : 80
                          }
                          height={
                            dt.source?.trim().toLocaleLowerCase() ===
                              'website' || !dt.source
                              ? 50
                              : 80
                          }
                          alt="review source"
                          style={{
                            top:
                              dt.source?.trim().toLocaleLowerCase() ===
                                'google' ||
                              dt.source?.trim().toLocaleLowerCase() ===
                                'expedia' ||
                              dt.source?.trim().toLocaleLowerCase() === 'viator'
                                ? '-10px'
                                : '8px'
                          }}
                          className="absolute right-3 "
                        />
                      </div>
                      <Rating
                        initialValue={dt?.rating}
                        disableFillHover={true}
                        allowFraction={true}
                        fillColor="orange"
                        emptyColor="#9B9B9B"
                        readonly={true}
                        SVGstyle={{
                          display: 'inline-block'
                        }}
                        size={15}
                      />
                      {productName !== undefined && (
                        <p className="text-base lg:text-lg font-semibold max-w-[240px] mt-5">
                          {productName?.length > 40
                            ? `${productName?.slice(0, 40)}...`
                            : productName}
                        </p>
                      )}
                      <p className="text-sm lg:text-base font-light text-justify">
                        {productName !== undefined ? (
                          dt?.review?.length > 90 ? (
                            <>
                              {`${dt.review.slice(0, 90)}`}
                              <span>....</span>
                              <span
                                className="font-semibold cursor-pointer"
                                onClick={() =>
                                  handleSeeMoreClick(dt, randomNames[index])
                                }
                              >
                                see more
                              </span>
                            </>
                          ) : (
                            dt.review
                          )
                        ) : dt?.review?.length > 200 ? (
                          <>
                            {`${dt.review.slice(0, 200)}`}
                            <span>....</span>
                            <span
                              className="font-semibold"
                              onClick={() =>
                                handleSeeMoreClick(dt, randomNames[index])
                              }
                            >
                              see more
                            </span>
                          </>
                        ) : (
                          dt.review
                        )}
                      </p>
                    </div>
                    <div className="flex text-sm relative flex-col md:flex-row md:justify-between mt-2 items-center">
                      <p className="text-sm lg:text-base font-semibold flex-1 ">
                        {dt.traveller === null
                          ? randomNames[index]
                          : dt.traveller}
                      </p>
                      <span className="text-xs">
                        {getTimeAgo(dt.created_at)}
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          {showModal && (
            <DetailedReviewModal
              setShowModal={setShowModal}
              productName={productName}
              data={selectedReview}
              randomName={selectedRandomName}
            />
          )}
          {heading === '' ? (
            <>
              <div
                style={{ left: '-23px', top: '50%' }}
                className="xxsm:hidden md:flex custom-prev-button absolute z-20 cursor-pointer xxsm:pl-[5px] md:pl-[0px]"
              >
                <LeftSwipperArrows isFirstSlide={isFirstSlide} />
              </div>
              <div
                style={{ right: '-23px', top: '50%' }}
                className="xxsm:hidden md:flex custom-next-button absolute z-20 cursor-pointer"
              >
                <RightSwipperArrows isLastSlide={isLastSlide} />
              </div>
            </>
          ) : (
            <div className="flex justify-center mt-5 ">
              <div className="flex gap-2 justify-center items-center">
                <div className="prevBtn">
                  <LeftSwipperArrows isFirstSlide={isFirstSlide} />
                </div>
                <div className="nextBtn">
                  <RightSwipperArrows isLastSlide={isLastSlide} />{' '}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
